import { createBrowserHistory, History } from 'history';
// Add history in Google Analytics
const history: History = createBrowserHistory();
export default history;
